import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useProfileStore } from "../store/profileStore";
import { useShallow } from "zustand/shallow";
import { getPrimaryNavFeatures, getLabel, type StudentContext } from "../config/featureVisibility";
import { useAuth } from "../store/authStore";

export default function MobileTabBar() {
  const { user } = useAuth();
  const location = useLocation();
  const { studentContext, loaded, fetchProfile } = useProfileStore(useShallow((s) => ({ studentContext: s.studentContext, loaded: s.loaded, fetchProfile: s.fetchProfile })));

  useEffect(() => { fetchProfile(); }, [fetchProfile]);

  if (!user) return null;

  const ctx: StudentContext = studentContext || { studentType: "UNDERGRADUATE", grade: "GRADE_11", isInternational: false };

  // Take the first 4 primary features + Home = 5 tabs
  const primary = loaded ? getPrimaryNavFeatures(ctx).slice(0, 4) : [];

  const tabs = [
    { path: "/dashboard", label: "Home", icon: "\u2302" },
    ...primary.map((f) => ({ path: f.path, label: getLabel(f, ctx), icon: f.icon })),
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 safe-area-pb" aria-label="Mobile navigation">
      <div className="flex items-center justify-around h-14">
        {tabs.map((tab) => {
          const active = location.pathname === tab.path || (tab.path !== "/dashboard" && location.pathname.startsWith(tab.path));
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 transition-colors ${
                active ? "text-blue-600" : "text-slate-400"
              }`}
            >
              <span className="text-lg leading-none">{tab.icon}</span>
              <span className="text-[10px] font-medium leading-none">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
